export default __webpack_public_path__ + "static/media/quality-check-grey.e7cdcd47.png";